import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedicalVisaIconUnselected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.6499 20.49L22.6124 5.64001C23.7374 4.51501 23.7374 2.71501 22.6124 1.70251C21.4874 0.690007 19.6874 0.577507 18.6749 1.70251L3.7124 16.5525L7.6499 20.49Z",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.7124 16.5527L0.899902 23.3027L7.6499 20.4902L3.7124 16.5527Z",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7124 1.92773H0.899902",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.2124 6.42773H0.899902",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.7124 10.9277H0.899902",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMedicalVisaIconUnselected;
